<script lang="ts" setup>
import { ref, reactive, onMounted, watch } from "vue";
//import BaseQueryChart from "./BaseQueryChart";
import DashboardChartsZuordnungenMenu from "@/components/dashboard/Charts/ZuordnungenMenu.vue";
import BaseVGrid from "@/components/BaseVGrid.vue";

import {
  initChartBase,
  ChartBaseProperties,
  ChartBaseUiData,
  getKZAufgabeDefiniton,
  ChartBaseParameters,
  refreshChartData,
} from "./ChartBaseStatic";
const props = defineProps<ChartBaseProperties>();
const emit = defineEmits(["refresh", "info"]);
const { ui, params } = initChartBase<ChartBaseUiData, ChartBaseParameters>(
  props,
  {},
  {}
);

const uiData = reactive<ChartBaseUiData>(ui);
let tableData: QueryResponse;

onMounted(async () => {
  refresh();
});
async function refresh() {
  try {
    uiData.showLoading = true;
    const data = await refreshChartData(uiData, props, params);
    dataLoaded(data);
  } catch (error) {
    console.error(error);
    uiData.showLoading = false;
  }
}
function dataLoaded(data: QueryResponse) {
  tableData = data;

}
</script>
<template>
  <v-btn size="x-small" icon="mdi-refresh" @click="refresh"> </v-btn>
  <v-progress-linear
    color="warning"
    indeterminate
    v-if="uiData.showLoading"
  />
  <DashboardChartsZuordnungenMenu
    :zuordnungen="uiData.zuordnungen"
    v-if="uiData.zuordnungen && uiData.zuordnungen.length > 0"
    :aic="params.aic"
  />
  <BaseVGrid :queryData="tableData"/>
</template>
